module.exports = __webpack_public_path__ + "img/crossred-icon.157e67d0.svg";